import { useCallback, useEffect, useRef, useState } from "react";
import contactsDirectoryApi from "../../../api/contactsDirectoryApi";
import { useContacts } from "../contexts/ContactsContext";

const PAGE_SIZE = 200;
const MAX_PAGES = 100;

/**
 * Hook load toàn bộ "Lời mời vào group" (hiện fallback: groups shop mới
 * join trong `days` ngày gần đây). Không phân trang.
 */
export const useGroupInvitations = ({ days = 30 } = {}) => {
  const { selectedShopIds, search } = useContacts();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;

    if (!selectedShopIds.length) {
      setItems([]);
      setTotal(0);
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const all = [];
      let totalCount = 0;
      let page = 1;
      while (page <= MAX_PAGES) {
        const data = await contactsDirectoryApi.getGroupInvitations(
          {
            shopIds: selectedShopIds,
            days,
            page,
            limit: PAGE_SIZE,
            search: search?.trim() || undefined,
          },
          ctrl.signal,
        );
        const rows = Array.isArray(data?.items) ? data.items : [];
        all.push(...rows);
        totalCount = data?.total || totalCount;
        if (rows.length < PAGE_SIZE) break;
        page += 1;
      }

      setItems(all);
      setTotal(totalCount || all.length);
    } catch (e) {
      if (e.name !== "CanceledError" && e.name !== "AbortError") {
        setError(e.message || "Lỗi tải danh sách");
      }
    } finally {
      setLoading(false);
    }
  }, [selectedShopIds, days, search]);

  useEffect(() => {
    load();
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [load]);

  return { items, total, loading, error, reload: load };
};

export default useGroupInvitations;
